import type { CohortNames } from '@bridebook/toolbox/src/ab-testing/lib/types';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';

export const getEnquiryCTAText = (
  isVenue: boolean,
  germanCopyVariant?: CohortNames | null,
): string => {
  if (!isVenue) return getI18n().t('common:enquiryCTA.nonVenue');

  if (germanCopyVariant === '1') return getI18n().t('common:cta.requestBrochure1');
  if (germanCopyVariant === '2') return getI18n().t('common:cta.requestBrochure2');
  if (germanCopyVariant === '3') return getI18n().t('common:cta.requestBrochure3');

  return getI18n().t('common:cta.requestBrochure');
};
